// MUI Components
import { Box } from '@mui/material';

// Contexts
import { useTheme } from '../../contexts/ThemeContext';

export default function ProgressBar({ percentage }) {
  const { theme } = useTheme();

  return (
    <Box sx={{ width: '100%', height: 6, bgcolor: theme.background.secondary, borderRadius: 3, mb: 3, boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.1)' }}>
      <Box
        sx={{
          height: '100%',
          bgcolor: theme.accent.success,
          borderRadius: 3,
          transition: 'width 0.5s ease-in-out',
          width: `${percentage}%`,
          boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
        }}
      />
    </Box>
  );
}
